<template>
    <div style="line-height: 35px; display:hidden ">
      <ul style="list-style: none; padding-left: 0px;margin-bottom: 0;">
        <li
          style="display: inline"
          v-for="(tradeType, index) in data"
          :key="index"
        >
          <span
            v-if="index < 3 || view_all"
            style="
              background: #5F2EEA;
              color: white;
              margin-right: 4px;
              padding: 5px 10px;
              border-radius: 5px;
              font-size: 11px;
            "
          >
            {{ tradeType.trade_type}}
          </span>
        </li>
        <span
            style="
              background: #5F2EEA;
              color: white;
              margin-right: 4px;
              padding: 5px 10px;
              border-radius: 5px;
              font-size: 11px;
              cursor: pointer;
            "
            @click="click_dot"
            >
                <span v-if="view_all"><</span>
                <span v-else>...</span>
            </span
          >
      </ul>
    </div>
  </template>

<script>
export default {
    name: 'inner_content',
    data(){
        return{
            view_all: false,
        }
    },
    props:{
        data: Array,
    },
    methods:{
        click_dot(){
            this.view_all = !this.view_all
        }
    }
}
</script>

<style>

</style>
